import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {LCProcessingResult} from "../_models/lc-processing-result";
import {Series} from "../_models/series";
// import {ChartComponent} from "angular2-highcharts";
import * as Highcharts from "highcharts";
import { HighchartsChartComponent } from "highcharts-angular";
import {Config} from "../config";
import {ApplicationService} from "../_services/application/application.service";
import { isDefined } from '@angular/compiler/src/util';
import { ConfigurationService } from '../_services/configuration/configuration.service';
import {TranslateService} from "@ngx-translate/core";
import { DateUtils } from '../_commons/date-utils';
import { UIUtils } from '../_commons/ui-utils';

@Component({
  selector: 'app-lc-dialog-details',
  templateUrl: './lc-dialog-details.component.html',
  styleUrls: ['./lc-dialog-details.component.css']
})
export class LcDialogDetailsComponent implements AfterViewInit {
  
  Highcharts: typeof Highcharts = Highcharts;

  @ViewChild('lossesChart', {static: false})
  public lossesChart: HighchartsChartComponent;

  @ViewChild('energyChart', {static: false})
  public energyChart: HighchartsChartComponent;

  @ViewChild('relativeLossesChart', {static: false})
  public relativeLossesChart: HighchartsChartComponent;

  @ViewChild('accumulatedLossesChart', {static: false})
  public accumulatedLossesChart: HighchartsChartComponent;

  @ViewChild('accumulatedEnergyChart', {static: false})
  public accumulatedEnergyChart: HighchartsChartComponent;

  @ViewChild('accumulatedRelativeLossesChart', {static: false})
  public accumulatedRelativeLossesChart: HighchartsChartComponent;

  public areLCDataAvailable: boolean = true;
  translations: any;
  lossesPerIntervalOptions: Highcharts.Options;
  energyPerIntervalOptions: Highcharts.Options;
  relativeLossesPerIntervalOptions: Highcharts.Options;
  accumulatedLossesPerIntervalOptions: Highcharts.Options;
  accumulatedEnergyPerIntervalOptions: Highcharts.Options;
  accumulatedRelativeEnergyPerIntervalOptions: Highcharts.Options;
  titleARRE12: string;
  titleARAEL11: string;
  titleARE10: string;
  titleAAE9: string;
  titleAREC8: string;
  titleAAEL7: string;
  titleRREC6: string;
  titleRAEL5: string;
  titleRE4: string;
  titleAE3: string;
  titleREC2: string;
  titleAEL1: string;
  private topology: any;


  constructor(
    private spinner: NgxSpinnerService,
    public activeModal: NgbActiveModal,
    private applicationService: ApplicationService,
    private configurationService: ConfigurationService,
    public translateService: TranslateService) {

    this.lossesPerIntervalOptions = {
      title: {
        text: 'Losses per interval'
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
              x: 0,
              y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: [
        {
          title: {
            text: 'Active Energy [Wh]'
          },
          allowDecimals: false,
          plotLines: [],
          labels: Config.chartYAxisLabelFormatterKilo,
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: 'Reactive Energy [VARh]'
          },
          labels: Config.chartYAxisLabelFormatterKilo,
        }
      ],
      legend: { ...Config.chartLegend, align: 'center', layout: 'horizontal' },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false
      },
    };

    this.energyPerIntervalOptions = {
      title: {
        text: 'Energy per interval'
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy"
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: [
        {
          title: {
            text: 'Active Energy [Wh]'
          },
          labels: Config.chartYAxisLabelFormatterKilo,
          plotLines: [],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: 'Reactive Energy [VARh]'
          },
          labels: Config.chartYAxisLabelFormatterKilo,
        }
      ],
      legend: { ...Config.chartLegend, align: 'center', layout: 'horizontal' },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false
      },
    };

    this.relativeLossesPerIntervalOptions = {
      title: {
        text: 'Relative Losses'
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
              x: 0,
              y: -45
          }
        },
        alignTicks: false
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: [
        {
          title: {
            text: 'Active Energy [%]'
          },
          labels: Config.chartYAxisLabelFormatterPercent,
          min: 0,
          // max: 120,
          endOnTick: true,
          plotLines: [],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: 'Reactive Energy [%]'
          },
          labels: Config.chartYAxisLabelFormatterPercent,
          min: 0,
          // max: 120,
        }
      ],
      legend:{ ...Config.chartLegend, align: 'center', layout: 'horizontal' },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false
      },
    };

    this.accumulatedLossesPerIntervalOptions = {
      title: {
        text: 'Accumulated Losses'
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
              x: 0,
              y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: [
        {
          title: {
            text: 'Accumulated Lost Energy [Wh]'
          },
          labels: Config.chartYAxisLabelFormatterKilo,
          plotLines: [],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: 'Accumulated Reactive Energy [VARh]'
          },
          labels: Config.chartYAxisLabelFormatterKilo
        }
      ],
      legend: { ...Config.chartLegend, align: 'center', layout: 'horizontal' },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false
      },
    };

    this.accumulatedEnergyPerIntervalOptions = {
      title: {
        text: 'Accumulated Energy'
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
              x: 0,
              y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: [
        {
          title: {
            text: 'Accumulated Active Energy [Wh]'
          },
          labels: Config.chartYAxisLabelFormatterKilo,
          plotLines: [],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: 'Accumulated Reactive Energy [VARh]'
          },
          labels: Config.chartYAxisLabelFormatterKilo
        }
      ],
      legend: { ...Config.chartLegend, align: 'center', layout: 'horizontal' },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false
      },
    };

    this.accumulatedRelativeEnergyPerIntervalOptions = {
      title: {
        text: 'Accumulated Relative Losses'
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
              x: 0,
              y: -45
          }
        },
        alignTicks: false
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: ''
        }
      },
      yAxis: [
        {
          title: {
            text: 'Accumulated Relative Losses [%]'
          },
          labels: Config.chartYAxisLabelFormatterPercent,
          plotLines: [],
          min: 0,
          // max: 120,
          endOnTick: true,
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: 'Accumulated Relative React. En. [%]'
          },
          labels: Config.chartYAxisLabelFormatterPercent,
          min: 0,
          // max: 120,
          endOnTick: true,
        }
      ],
      legend: { ...Config.chartLegend, align: 'center', layout: 'horizontal' },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false
      },
    };

    // Translations
    const language = localStorage.getItem("Language");

    translateService.getTranslation(language).subscribe((translations) => {
      console.log("Translations: ", translations);
      this.translations = translations;

      if(!Array.isArray(this.lossesPerIntervalOptions.xAxis)){
        this.lossesPerIntervalOptions.title.text = translations["lc-code-string"]["Losses-per-interval"];
      }
      (this.lossesPerIntervalOptions.xAxis as Highcharts.XAxisOptions).title.text = translations["lc-code-string"]["Time-intervals"];
      this.lossesPerIntervalOptions.yAxis[0].title.text = translations["lc-code-string"]["Active-Energy"] + " [Wh]";
      this.lossesPerIntervalOptions.yAxis[1].title.text = translations["lc-code-string"]["Reactive-Energy"] + " [VARh]";

      if(!Array.isArray(this.energyPerIntervalOptions.xAxis)){
        this.energyPerIntervalOptions.title.text = translations["lc-code-string"]["Energy-per-interval"];
      }
      (this.energyPerIntervalOptions.xAxis as Highcharts.XAxisOptions).title.text = translations["lc-code-string"]["Time-intervals"];
      this.energyPerIntervalOptions.yAxis[0].title.text = translations["lc-code-string"]["Active-Energy"] + " [Wh]";
      this.energyPerIntervalOptions.yAxis[1].title.text = translations["lc-code-string"]["Reactive-Energy"] + " [VARh]";

      if(!Array.isArray(this.relativeLossesPerIntervalOptions.xAxis)){
        this.relativeLossesPerIntervalOptions.title.text = translations["lc-code-string"]["Relative-Losses"];
      }
      (this.relativeLossesPerIntervalOptions.xAxis as Highcharts.XAxisOptions).title.text = translations["lc-code-string"]["Time-intervals"];
      this.relativeLossesPerIntervalOptions.yAxis[0].title.text = translations["lc-code-string"]["Active-Energy"] + " [%]";
      this.relativeLossesPerIntervalOptions.yAxis[1].title.text = translations["lc-code-string"]["Reactive-Energy"] + " [%]";

      if(!Array.isArray(this.accumulatedLossesPerIntervalOptions.xAxis)){
        this.accumulatedLossesPerIntervalOptions.title.text = translations["lc-code-string"]["Accumulated-Losses"];
      }
      (this.accumulatedLossesPerIntervalOptions.xAxis as Highcharts.XAxisOptions).title.text = translations["lc-code-string"]["Time-intervals"];
      this.accumulatedLossesPerIntervalOptions.yAxis[0].title.text = translations["lc-code-string"]["Accumulated-Lost-Energy"] + " [Wh]";
      this.accumulatedLossesPerIntervalOptions.yAxis[1].title.text = translations["lc-code-string"]["Accumulated-Reactive-Energy"] + " [VARh]";

      if(!Array.isArray(this.accumulatedEnergyPerIntervalOptions.xAxis)){
        this.accumulatedEnergyPerIntervalOptions.title.text = translations["lc-code-string"]["Accumulated-Energy"];
      }
      (this.accumulatedEnergyPerIntervalOptions.xAxis as Highcharts.XAxisOptions).title.text = translations["lc-code-string"]["Time-intervals"];
      this.accumulatedEnergyPerIntervalOptions.yAxis[0].title.text = translations["lc-code-string"]["Accumulated-Active-Energy"] + " [Wh]";
      this.accumulatedEnergyPerIntervalOptions.yAxis[1].title.text = translations["lc-code-string"]["Accumulated-Reactive-Energy"] + " [VARh]";

      if(!Array.isArray(this.accumulatedRelativeEnergyPerIntervalOptions.xAxis)){
        this.accumulatedRelativeEnergyPerIntervalOptions.title.text = translations["lc-code-string"]["Accumulated-Relative-Losses"];
      }
      (this.accumulatedRelativeEnergyPerIntervalOptions.xAxis as Highcharts.XAxisOptions).title.text = translations["lc-code-string"]["Time-intervals"];      
      this.accumulatedRelativeEnergyPerIntervalOptions.yAxis[0].title.text = translations["lc-code-string"]["Accumulated-Relative-Losses"] + " [%]";
      this.accumulatedRelativeEnergyPerIntervalOptions.yAxis[1].title.text = translations["lc-code-string"]["Accumulated-Relative-React-En"] + " [%]";


      this.titleARRE12 = translations["lc-code-string"]["Acc-Relative-React-En-Contribution-by-Cables-and-Lines"];
      this.titleARAEL11 = translations["lc-code-string"]["Acc-Relative-Active-Energy-Losses"];
      this.titleARE10 = translations["lc-code-string"]["Accumulated-Reactive-Energy-at"];
      this.titleAAE9 = translations["lc-code-string"]["Accumulated-Active-Energy-at"];
      this.titleAREC8 = translations["lc-code-string"]["Accumulated-React-En-Contribution-by-Cables-and-Lines"];
      this.titleAAEL7 = translations["lc-code-string"]["Accumulated-Active-Energy-Losses"];
      this.titleRREC6 = translations["lc-code-string"]["Relative-React-En-Contribution-by-Cables-and-Lines"];
      this.titleRAEL5 = translations["lc-code-string"]["Relative-Active-Energy-Losses"];
      this.titleRE4 = translations["lc-code-string"]["Reactive-Energy-at"];
      this.titleAE3 = translations["lc-code-string"]["Active-Energy-at"];
      this.titleREC2 = translations["lc-code-string"]["React-En-Contribution-by-Cables-and-Lines"];
      this.titleAEL1 = translations["lc-code-string"]["Active-Energy-Losses"];
    });
  }

  ngAfterViewInit() {
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    this.buildCharts();
  }

  buildCharts() {
    setTimeout(() => {
    });
    this.applicationService.getAllLCData(this.topology.topologyId).subscribe((lcProcessingResults: LCProcessingResult) => {
      if (lcProcessingResults == null) {
        this.areLCDataAvailable = false;
        
        return;
      }
      const outputReactiveEnergy = lcProcessingResults.outputReactiveEnergy;
      console.log("outputReactiveEnergy", lcProcessingResults.outputReactiveEnergy);
      if (outputReactiveEnergy) {
        this.lcResultWithReactiveEnergy(lcProcessingResults);
      } else if (!outputReactiveEnergy) {
        this.lcResultWithoutReactiveEnergy(lcProcessingResults);
      }      
    });
  }

  private lcResultWithReactiveEnergy(lcProcessingResults: LCProcessingResult) {
    const xAxisCategories: Map<string, string> = new Map<string, string>();

    const lossSeries: Array<Series> = new Array<Series>();
    const energySeries: Array<Series> = new Array<Series>();
    const relativeLossSeries: Array<Series> = new Array<Series>();
    const accumulatedLossSeries: Array<Series> = new Array<Series>();
    const accumulatedEnergySeries: Array<Series> = new Array<Series>();
    const accumulatedRelativeEnergySeries: Array<Series> = new Array<Series>();

    // Chart 1 data
    const activeEnergyLossData: Array<number> = new Array<number>();
    const reactiveEnergyLossData: Array<number> = new Array<number>();

    // Chart 2 data
    const activeEnergyAtTrafoData: Array<number> = new Array<number>();
    const reactiveEnergyAtTrafoData: Array<number> = new Array<number>();

    // Chart 3 data
    const relativeActiveEnergyLossData: Array<number> = new Array<number>();
    const relativeReactiveEnergyLossData: Array<number> = new Array<number>();

    // Chart 4 data
    const accumulatedActiveEnergyLossData: Array<number> = new Array<number>();
    const accumulatedReactiveEnergyLossData: Array<number> = new Array<number>();

    // Chart 5 data
    const accumulatedActiveEnergyAtTrafoData: Array<number> = new Array<number>();
    const accumulatedReactiveEnergyAtTrafoData: Array<number> = new Array<number>();

    // Chart 6 data
    const accumulatedRelativeActiveEnergyLossData: Array<number> = new Array<number>();
    const accumulatedRelativeReactiveEnergyLossData: Array<number> = new Array<number>();


    lcProcessingResults.intervals.forEach((value, index) => {
      const timestamp = value.timestamp;
      xAxisCategories.set(timestamp, timestamp);

      activeEnergyLossData.push(
        parseFloat((value.activeEnergyLoss / 1000).toFixed(3)));

      reactiveEnergyLossData.push(
        parseFloat((value.reactiveEnergyLoss / 1000).toFixed(3)));

      activeEnergyAtTrafoData.push(
        parseFloat((value.activeEnergyAtTrafo / 1000).toFixed(3)));

      reactiveEnergyAtTrafoData.push(
        parseFloat((value.reactiveEnergyAtTrafo / 1000).toFixed(3)));

      if (value.activeEnergyAtTrafo !== 0) {
        relativeActiveEnergyLossData.push(
          parseFloat(((Math.abs(value.activeEnergyLoss / value.activeEnergyAtTrafo) * 100)).toFixed(3)));
      }
      if (value.reactiveEnergyAtTrafo !== 0) {
        relativeReactiveEnergyLossData.push(
          parseFloat(((Math.abs(value.reactiveEnergyLoss / value.reactiveEnergyAtTrafo) * 100)).toFixed(3)));
      }

      accumulatedActiveEnergyLossData.push(
        parseFloat((value.accumulatedActiveEnergyLoss / 1000).toFixed(3)));

      accumulatedReactiveEnergyLossData.push(
        parseFloat((value.accumulatedReactiveEnergyLoss / 1000).toFixed(3)));

      accumulatedActiveEnergyAtTrafoData.push(
        parseFloat((value.accumulatedActiveEnergyAtTrafo / 1000).toFixed(3)));

      accumulatedReactiveEnergyAtTrafoData.push(
        parseFloat((value.accumulatedReactiveEnergyAtTrafo / 1000).toFixed(3)));

      if (value.accumulatedActiveEnergyAtTrafo !== 0) {
        accumulatedRelativeActiveEnergyLossData.push(
          parseFloat(((Math.abs(value.accumulatedActiveEnergyLoss / value.accumulatedActiveEnergyAtTrafo) * 100)).toFixed(3)));
      }
      if (value.accumulatedReactiveEnergyAtTrafo !== 0) {
        accumulatedRelativeReactiveEnergyLossData.push(
          parseFloat(((Math.abs(value.accumulatedReactiveEnergyLoss / value.accumulatedReactiveEnergyAtTrafo) * 100)).toFixed(3)));
      }

    });

    const tooltipKWh = Config.getChartTooltip("kWh");
    const tooltipKVARh = Config.getChartTooltip("kVARh");
    const tooltipPercentage = Config.getChartTooltip("%");


    const activeEnergyLossSeriesObj = new Series(
      this.titleAEL1,
      activeEnergyLossData
    );
    activeEnergyLossSeriesObj.tooltip = tooltipKWh;
    activeEnergyLossSeriesObj.color = "#85D9FF";

    lossSeries.push(activeEnergyLossSeriesObj);

    const reactiveEnergyLossSeriesObj = new Series(
      this.titleREC2,
      reactiveEnergyLossData
    );
    // console.log("LC-reactiveEnergyLossData " + reactiveEnergyLossData);
    reactiveEnergyLossSeriesObj.yAxis = 1;
    reactiveEnergyLossSeriesObj.tooltip = tooltipKVARh;
    reactiveEnergyLossSeriesObj.color = "black";

    lossSeries.push(reactiveEnergyLossSeriesObj);


    const activeEnergyAtTrafoSeriesObj = new Series(
      this.titleAE3 + this.configurationService.getConfiguration().rootNodeName,
      activeEnergyAtTrafoData
    );
    activeEnergyAtTrafoSeriesObj.tooltip = tooltipKWh;
    activeEnergyAtTrafoSeriesObj.color = "#85D9FF";
    energySeries.push(activeEnergyAtTrafoSeriesObj);

    const reactiveEnergyAtTrafoSeriesObj = new Series(
      this.titleRE4 + this.configurationService.getConfiguration().rootNodeName,
      reactiveEnergyAtTrafoData
    );
    reactiveEnergyAtTrafoSeriesObj.yAxis = 1;
    reactiveEnergyAtTrafoSeriesObj.tooltip = tooltipKVARh;
    reactiveEnergyAtTrafoSeriesObj.color = "black";
    energySeries.push(reactiveEnergyAtTrafoSeriesObj);


    const relativeActiveEnergyLossSeriesObj = new Series(
      this.titleRAEL5,
      relativeActiveEnergyLossData
    );
    relativeActiveEnergyLossSeriesObj.tooltip = tooltipPercentage;
    relativeActiveEnergyLossSeriesObj.color = "#85D9FF";
    relativeLossSeries.push(relativeActiveEnergyLossSeriesObj);


    const relativeReactiveEnergyLossSeriesObj = new Series(
      this.titleRREC6,
      relativeReactiveEnergyLossData
    );
    relativeReactiveEnergyLossSeriesObj.yAxis = 1;
    relativeReactiveEnergyLossSeriesObj.tooltip = tooltipPercentage;
    relativeReactiveEnergyLossSeriesObj.color = "black";
    relativeLossSeries.push(relativeReactiveEnergyLossSeriesObj);


    const accumulatedActiveEnergyLossSeriesObj = new Series(
      this.titleAAEL7,
      accumulatedActiveEnergyLossData
    );
    accumulatedActiveEnergyLossSeriesObj.tooltip = tooltipKWh;
    accumulatedActiveEnergyLossSeriesObj.color = "#85D9FF";
    accumulatedLossSeries.push(accumulatedActiveEnergyLossSeriesObj);

    const accumulatedReactiveEnergyLossSeriesObj = new Series(
      this.titleAREC8,
      accumulatedReactiveEnergyLossData
    );
    accumulatedReactiveEnergyLossSeriesObj.yAxis = 1;
    accumulatedReactiveEnergyLossSeriesObj.tooltip = tooltipKVARh;
    accumulatedReactiveEnergyLossSeriesObj.color = "black";
    accumulatedLossSeries.push(accumulatedReactiveEnergyLossSeriesObj);

    const accumulatedActiveEnergyAtTrafoSeriesObj = new Series(
      this.titleAAE9 + this.configurationService.getConfiguration().rootNodeName,
      accumulatedActiveEnergyAtTrafoData
    );
    accumulatedActiveEnergyAtTrafoSeriesObj.tooltip = tooltipKWh;
    accumulatedActiveEnergyAtTrafoSeriesObj.color = "#85D9FF";
    accumulatedEnergySeries.push(accumulatedActiveEnergyAtTrafoSeriesObj);

    const accumulatedReactiveEnergyAtTrafoSeriesObj = new Series(
      this.titleARE10 + this.configurationService.getConfiguration().rootNodeName,
      accumulatedReactiveEnergyAtTrafoData
    );
    accumulatedReactiveEnergyAtTrafoSeriesObj.yAxis = 1;
    accumulatedReactiveEnergyAtTrafoSeriesObj.tooltip = tooltipKVARh;
    accumulatedReactiveEnergyAtTrafoSeriesObj.color = "black";
    accumulatedEnergySeries.push(accumulatedReactiveEnergyAtTrafoSeriesObj);


    const accumulatedRelativeActiveEnergyLossSeriesObj = new Series(
      this.titleARAEL11,
      accumulatedRelativeActiveEnergyLossData
    );
    accumulatedRelativeActiveEnergyLossSeriesObj.tooltip = tooltipPercentage;
    accumulatedRelativeActiveEnergyLossSeriesObj.color = "#85D9FF";
    accumulatedRelativeEnergySeries.push(accumulatedRelativeActiveEnergyLossSeriesObj);

    const accumulatedRelativeEnergyLossSeriesObj = new Series(
      this.titleARRE12,
      accumulatedRelativeReactiveEnergyLossData
    );
    accumulatedRelativeEnergyLossSeriesObj.yAxis = 1;
    accumulatedRelativeEnergyLossSeriesObj.tooltip = tooltipPercentage;
    accumulatedRelativeEnergyLossSeriesObj.color = "black";
    accumulatedRelativeEnergySeries.push(accumulatedRelativeEnergyLossSeriesObj);

    // Render X axis
    xAxisCategories.forEach((key: string) => {
      if (!Array.isArray(this.lossesPerIntervalOptions.xAxis) && this.lossesPerIntervalOptions.xAxis) {
        this.lossesPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.energyPerIntervalOptions.xAxis) && this.energyPerIntervalOptions.xAxis) {
        this.energyPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.relativeLossesPerIntervalOptions.xAxis) && this.relativeLossesPerIntervalOptions.xAxis) {
        this.relativeLossesPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.accumulatedLossesPerIntervalOptions.xAxis) && this.accumulatedLossesPerIntervalOptions.xAxis) {
        this.accumulatedLossesPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.accumulatedEnergyPerIntervalOptions.xAxis) && this.accumulatedEnergyPerIntervalOptions.xAxis) {
        this.accumulatedEnergyPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.accumulatedRelativeEnergyPerIntervalOptions.xAxis) && this.accumulatedRelativeEnergyPerIntervalOptions.xAxis) {
        this.accumulatedRelativeEnergyPerIntervalOptions.xAxis.categories.push(key);
      }
    });

    this.lossesPerIntervalOptions.series = JSON.parse(JSON.stringify(lossSeries));
    console.log(JSON.stringify(this.lossesPerIntervalOptions));


    this.energyPerIntervalOptions.series = JSON.parse(JSON.stringify(energySeries));
    console.log(JSON.stringify(this.energyPerIntervalOptions));

    this.relativeLossesPerIntervalOptions.series = JSON.parse(JSON.stringify(relativeLossSeries));
    console.log(JSON.stringify(this.relativeLossesPerIntervalOptions));

    this.accumulatedLossesPerIntervalOptions.series = JSON.parse(JSON.stringify(accumulatedLossSeries));
    console.log(JSON.stringify(this.accumulatedLossesPerIntervalOptions));

    this.accumulatedEnergyPerIntervalOptions.series = JSON.parse(JSON.stringify(accumulatedEnergySeries));
    console.log(JSON.stringify(this.accumulatedEnergyPerIntervalOptions));

    this.accumulatedRelativeEnergyPerIntervalOptions.series = JSON.parse(JSON.stringify(accumulatedRelativeEnergySeries));
    console.log(JSON.stringify(this.accumulatedRelativeEnergyPerIntervalOptions));

    if (this.lossesChart) {
      this.lossesChart.options = this.lossesPerIntervalOptions;
    }

    if (this.energyChart) {
      this.energyChart.options = this.energyPerIntervalOptions;
    }

    if (this.relativeLossesChart) {
      this.relativeLossesChart.options = this.relativeLossesPerIntervalOptions;
    }

    if (this.accumulatedLossesChart) {
      this.accumulatedLossesChart.options = this.accumulatedLossesPerIntervalOptions;
    }

    if (this.accumulatedEnergyChart) {
      this.accumulatedEnergyChart.options = this.accumulatedEnergyPerIntervalOptions;
    }

    if (this.accumulatedRelativeLossesChart) {
      this.accumulatedRelativeLossesChart.options = this.accumulatedRelativeEnergyPerIntervalOptions;
    }

  }

  private lcResultWithoutReactiveEnergy(lcProcessingResults: LCProcessingResult) {
    const xAxisCategories: Map<string, string> = new Map<string, string>();

    const lossSeries: Array<Series> = new Array<Series>();
    const energySeries: Array<Series> = new Array<Series>();
    const relativeLossSeries: Array<Series> = new Array<Series>();
    const accumulatedLossSeries: Array<Series> = new Array<Series>();
    const accumulatedEnergySeries: Array<Series> = new Array<Series>();
    const accumulatedRelativeEnergySeries: Array<Series> = new Array<Series>();

    // Chart 1 data
    const activeEnergyLossData: Array<number> = new Array<number>();

    // Chart 2 data
    const activeEnergyAtTrafoData: Array<number> = new Array<number>();

    // Chart 3 data
    const relativeActiveEnergyLossData: Array<number> = new Array<number>();

    // Chart 4 data
    const accumulatedActiveEnergyLossData: Array<number> = new Array<number>();

    // Chart 5 data
    const accumulatedActiveEnergyAtTrafoData: Array<number> = new Array<number>();

    // Chart 6 data
    const accumulatedRelativeActiveEnergyLossData: Array<number> = new Array<number>();

    lcProcessingResults.intervals.forEach((value, index) => {
      const timestamp = value.timestamp;
      xAxisCategories.set(timestamp, timestamp);

      activeEnergyLossData.push(
        parseFloat((value.activeEnergyLoss / 1000).toFixed(3)));

      activeEnergyAtTrafoData.push(
        parseFloat((value.activeEnergyAtTrafo / 1000).toFixed(3)));

      if (value.activeEnergyAtTrafo !== 0) {
        relativeActiveEnergyLossData.push(
          parseFloat(((Math.abs(value.activeEnergyLoss / value.activeEnergyAtTrafo) * 100)).toFixed(3)));
      }

      accumulatedActiveEnergyLossData.push(
        parseFloat((value.accumulatedActiveEnergyLoss / 1000).toFixed(3)));

      accumulatedActiveEnergyAtTrafoData.push(
        parseFloat((value.accumulatedActiveEnergyAtTrafo / 1000).toFixed(3)));

      if (value.accumulatedActiveEnergyAtTrafo !== 0) {
        accumulatedRelativeActiveEnergyLossData.push(
          parseFloat(((Math.abs(value.accumulatedActiveEnergyLoss / value.accumulatedActiveEnergyAtTrafo) * 100)).toFixed(3)));
      }


    });

    const tooltipKWh = Config.getChartTooltip("kWh");
    const tooltipKVARh = Config.getChartTooltip("kVARh");
    const tooltipPercentage = Config.getChartTooltip("%");

    console.log("title1", this.titleAEL1);
    const activeEnergyLossSeriesObj = new Series(
      this.titleAEL1,
      activeEnergyLossData
    );
    activeEnergyLossSeriesObj.tooltip = tooltipKWh;
    lossSeries.push(activeEnergyLossSeriesObj);

    const activeEnergyAtTrafoSeriesObj = new Series(
      this.titleAE3 + this.configurationService.getConfiguration().rootNodeName,
      activeEnergyAtTrafoData
    );
    activeEnergyAtTrafoSeriesObj.tooltip = tooltipKWh;
    energySeries.push(activeEnergyAtTrafoSeriesObj);

    const relativeActiveEnergyLossSeriesObj = new Series(
      this.titleRAEL5,
      relativeActiveEnergyLossData
    );
    relativeActiveEnergyLossSeriesObj.tooltip = tooltipPercentage;
    relativeLossSeries.push(relativeActiveEnergyLossSeriesObj);

    const accumulatedActiveEnergyLossSeriesObj = new Series(
      this.titleAAEL7,
      accumulatedActiveEnergyLossData
    );
    accumulatedActiveEnergyLossSeriesObj.tooltip = tooltipKWh;
    accumulatedLossSeries.push(accumulatedActiveEnergyLossSeriesObj);

    const accumulatedActiveEnergyAtTrafoSeriesObj = new Series(
      this.titleAAE9 + this.configurationService.getConfiguration().rootNodeName,
      accumulatedActiveEnergyAtTrafoData
    );
    accumulatedActiveEnergyAtTrafoSeriesObj.tooltip = tooltipKWh;
    accumulatedEnergySeries.push(accumulatedActiveEnergyAtTrafoSeriesObj);

    const accumulatedRelativeActiveEnergyLossSeriesObj = new Series(
      this.titleARAEL11,
      accumulatedRelativeActiveEnergyLossData
    );
    accumulatedRelativeActiveEnergyLossSeriesObj.tooltip = tooltipPercentage;
    accumulatedRelativeEnergySeries.push(accumulatedRelativeActiveEnergyLossSeriesObj);

    // Render X axis
    xAxisCategories.forEach((key: string) => {
      if (!Array.isArray(this.lossesPerIntervalOptions.xAxis) && this.lossesPerIntervalOptions.xAxis) {
        this.lossesPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.energyPerIntervalOptions.xAxis) && this.energyPerIntervalOptions.xAxis) {
        this.energyPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.relativeLossesPerIntervalOptions.xAxis) && this.relativeLossesPerIntervalOptions.xAxis) {
        this.relativeLossesPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.accumulatedLossesPerIntervalOptions.xAxis) && this.accumulatedLossesPerIntervalOptions.xAxis) {
        this.accumulatedLossesPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.accumulatedEnergyPerIntervalOptions.xAxis) && this.accumulatedEnergyPerIntervalOptions.xAxis) {
        this.accumulatedEnergyPerIntervalOptions.xAxis.categories.push(key);
      }
      if (!Array.isArray(this.accumulatedRelativeEnergyPerIntervalOptions.xAxis) && this.accumulatedRelativeEnergyPerIntervalOptions.xAxis) {
        this.accumulatedRelativeEnergyPerIntervalOptions.xAxis.categories.push(key);
      }
    });

    this.lossesPerIntervalOptions.series = JSON.parse(JSON.stringify(lossSeries));
    console.log(JSON.stringify(this.lossesPerIntervalOptions));
    this.lossesPerIntervalOptions.yAxis[1].title.text = "";


    this.energyPerIntervalOptions.series = JSON.parse(JSON.stringify(energySeries));
    console.log(JSON.stringify(this.energyPerIntervalOptions));
    this.relativeLossesPerIntervalOptions.yAxis[1].title.text = "";
    this.energyPerIntervalOptions.yAxis[1].title.text = "";

    this.relativeLossesPerIntervalOptions.series = JSON.parse(JSON.stringify(relativeLossSeries));
    console.log(JSON.stringify(this.relativeLossesPerIntervalOptions));

    this.accumulatedLossesPerIntervalOptions.series = JSON.parse(JSON.stringify(accumulatedLossSeries));
    console.log(JSON.stringify(this.accumulatedLossesPerIntervalOptions));
    this.accumulatedLossesPerIntervalOptions.yAxis[1].title.text = "";

    this.accumulatedEnergyPerIntervalOptions.series = JSON.parse(JSON.stringify(accumulatedEnergySeries));
    console.log(JSON.stringify(this.accumulatedEnergyPerIntervalOptions));

    this.accumulatedEnergyPerIntervalOptions.yAxis[1].title.text = "";
    this.accumulatedRelativeEnergyPerIntervalOptions.yAxis[1].title.text = "";

    this.accumulatedRelativeEnergyPerIntervalOptions.series = JSON.parse(JSON.stringify(accumulatedRelativeEnergySeries));
    console.log(JSON.stringify(this.accumulatedRelativeEnergyPerIntervalOptions));

    if (this.lossesChart) {
      this.lossesChart.options = this.lossesPerIntervalOptions;
    }

    if (this.energyChart) {
      this.energyChart.options = this.energyPerIntervalOptions; }

    if (this.relativeLossesChart) {
      this.relativeLossesChart.options = this.relativeLossesPerIntervalOptions; }

    if (this.accumulatedLossesChart) {
      this.accumulatedLossesChart.options = this.accumulatedLossesPerIntervalOptions; }

    if (this.accumulatedEnergyChart) {
      this.accumulatedEnergyChart.options = this.accumulatedEnergyPerIntervalOptions; }

    if (this.accumulatedRelativeLossesChart) {
      this.accumulatedRelativeLossesChart.options = this.accumulatedRelativeEnergyPerIntervalOptions;
    }
  }
}
